import {ReactElement, useEffect} from 'react';
import BaseLayout from '../../Components/shared/BaseLayout';
import ActivationForm from '../../Components/Membership/ActivationForm';
import analyticsService, {ANALYTICS_EVENTS} from '../../analyticsService';

const Membership = (): ReactElement => {
    useEffect(() => {
        analyticsService.track(ANALYTICS_EVENTS.membership.pageOpened);
    }, []);

    return (
        <BaseLayout>
            <ActivationForm/>
        </BaseLayout>
    );
};

export {Membership as TestableMembership};
export default Membership;
